'use strict'
module.exports = {
  NODE_ENV: '"production"',
  SERVER_ENDPOINT: '"https://api-vb.ovbo.io"',
  LOGO_NAME: "'logo.svg'",
  EXTRAS: [],
  SERVER_SIDE: {}
}
